import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';

import ResourcesService from '@/core/services/resources.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class CreateResourcesComponent extends Vue {

  resourcesService: any = new ResourcesService();
  sidebarService: any = new SidebarService();
  genericErr: any = [];
  sectionList: any = [];
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  resourcesList: any = [];
  section: string = "defaultSection";
  name: string = "";
  title: string = "";
  type: string = "defaultType";
  file: string = "";


  mounted (){
    const _ = this;
    _.getSection();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  getSection(){
    const _ = this;
    _.isLoading = true;
    _.resourcesService.getSection().then((data: any) => {
      _.sectionList = data['data'].sections;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
      }
      _.isLoading = false;
    })
  }

  create(){
    const _ = this;
    let resource = _.file;
    console.log(resource);
    _.isLoading = true;
    _.resourcesService.create(resource).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/resources');
      }, 2000)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
  }

  changeResources(){
    const _ = this;
    _.file = new FormData();
    _.file.append('name', _.name);
    _.file.append('type', _.type);
    _.file.append('file', document.querySelector('.file').files[0]);
    for (var p of _.file) {
      console.log(p);
    }
  }

  validations(name = ''){
    const _ = this;
    _.genericErr = [];
    if(name == ''){
      _.genericErr.push("por favor introduce un nombre");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.create()
  }
}
